import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConsultaDto, IGetConsultas } from '../../shared/interfaces/database/kpi';
import { Page, Utils } from 'lib-base';
import { TableLazyLoadEvent } from 'primeng/table';

@Injectable({
  providedIn: 'root'
})
export class ConsultasService {
  private readonly baseUrl = `${environment.apiUrl}/api/kpi/consultas`;

  constructor(private readonly http: HttpClient) { }

  findAll(event: TableLazyLoadEvent): Observable<Page<IGetConsultas>> {
    const params = Utils.getLazyLoadParams(event ?? {});
    return this.http.get<Page<IGetConsultas>>(`${this.baseUrl}`, { params });
  }

  create(request: ConsultaDto): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}`, request);
  }

  update(id: number, request: ConsultaDto): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
